import React, { useState } from "react";
import "../Navbar/Navbar.css";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const callAdmin = () => {
    window.location.href = "tel: +910000000000"; // replace with real number
  };
  return (
    <nav className="navbar">
      {/* Left: Logo */}
      <div className="navbar-logo">
        <Link to="/">
          <img src="/logo.webp" alt="logo" className="navlogo" />
        </Link>
      </div>

      {/* Center: Navigation Links - Desktop */}
      <ul className="navbar-links">
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/aboutus">About Us</Link>
        </li>
        <li>
          <Link to="/case-studies">Case Study</Link>
        </li>
        <li>
          <Link to="/practicearea">Practice Area</Link>
        </li>
        <li>
          <Link to="/contactus">Contact Us</Link>
        </li>
      </ul>

      {/* Right: Consultation Button - Desktop */}
      <div className="navbar-button">
        <button>Consultation</button>
      </div>

      {/* Mobile Menu Button */}
      <div className="hamburger-menu" onClick={toggleMenu}>
        <div className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></div>
        <div className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></div>
        <div className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></div>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`mobile-menu-overlay ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      ></div>

      {/* Mobile Menu Content - Growing from hamburger */}
      <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <ul className="mobile-links">
          <li>
            <Link to="/" onClick={toggleMenu}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/aboutus" onClick={toggleMenu}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/case-studies" onClick={toggleMenu}>
              Case Study
            </Link>
          </li>
          <li>
            <Link to="/practicearea" onClick={toggleMenu}>
              Practice Area
            </Link>
          </li>
          <li>
            <Link to="/contactus" onClick={toggleMenu}>
              Contact Us
            </Link>
          </li>
          <li className="mobile-button">
            <button onClick={callAdmin}>Consultation</button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
